const arrayToGridLike = (arr: any[], numColumns: number) => {
  if (numColumns < 1) {
    console.warn(`${arr} > ${numColumns} : WILL NOT PRODUCE A ' GRID ' !!!`);
    return arr;
  }
  //

  const _: any[] = [...arr];
  const $: any[] = [];

  while (_.length) {
    $.push(_.splice(0, numColumns));
  }

  return $;
};

export default arrayToGridLike;
